import { Moon, Sun } from "lucide-react"
import { useTheme } from "@/components/theme-provider"
import { cn } from "@/lib/utils"

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()

  const nextLabel = theme === "light" ? "Switch to dark mode" : "Switch to light mode"

  function handleClick() {
    const next = theme === "light" ? "dark" : "light"
    setTheme(next)
    try {
      // Light haptic feedback on supporting mobile devices
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const nav: any = navigator
      if (nav && typeof nav.vibrate === "function") {
        nav.vibrate(10)
      }
    } catch (_) {}
  }

  return (
    <button
      type="button"
      role="switch"
      aria-checked={theme === "dark"}
      onClick={handleClick}
      aria-label={nextLabel}
      title={nextLabel}
      className={cn(
        "relative inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors",
        "min-touch-target p-2.5 sm:p-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
      )}
    >
      <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      <span className="sr-only">Toggle theme</span>
    </button>
  )
}
